import { Box, BoxProps } from '@mui/material';

export const BoxComponent: React.FC<BoxProps | any> = props => {
  return <Box {...props}>{props.children}</Box>;
};
